module.exports = __webpack_public_path__ + "static/media/data.2b0ae2cf.svg";